module.exports = __webpack_public_path__ + "static/media/model-shogun-sport-00.bead4fe2.jpg";